/** @jsx jsx */
import { jsx } from "theme-ui"
import { useRef } from "react"

const Expander = ({ open = false, styles, children }) => {
  const ref = useRef(null)

  let height = 0
  if (open && ref.current) {
    height = ref.current.scrollHeight + "px"
  } else if (open) {
    height = null
  }

  return (
    <div
      ref={ref}
      sx={{
        maxHeight: height,
        overflow: "hidden",
        transition: "max-height ease 0.3s",
        ...styles,
      }}
    >
      <div>{children}</div>
    </div>
  )
}

export default Expander
